import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import TreeItemEnclusure from "./TreeItemEnclosure";
import { graphql, createFragmentContainer } from "react-relay";
import { useTheme } from "../contexts/ThemeContext";
import { getNodeValue } from "../utils";
import "./Tree.css";
import { Grid16 } from "@carbon/icons-react";
import TreeNodeFolder from "./TreeNodeFolder";
import TreeEdgesEnclosure from "./TreeEdgesEnclosure";
import { commitLocalUpdate } from "react-relay";
import { updateLocalSetting } from "../Environment";
import environment from "../Environment";
import { useNavigate } from "react-router-dom";

function Tree(props) {
    const { user_Subscription } = props;
    const settings = props.settings;
    let userSub = user_Subscription.userSubscriptions.edges;
    const theme = useTheme();
    const navigate = useNavigate();

    let expanded = true;

    function onParentClick(e) {
        e.preventDefault();
        let feedArr = [];
        const data = [];

        for (var i = 0; i < userSub.length; i++) {
            if (userSub[i].node) {
                if (userSub[i].node.parent === null) {
                    data.push({
                        id: userSub[i].node.id,
                        parentId: userSub[i].node.parent,
                        name: userSub[i].node.name,
                    });
                } else {
                    if (userSub[i].node.source) {
                        data.push({
                            id: userSub[i].node.source.id,
                            parentId: userSub[i].node.parent.id,
                            name: userSub[i].node.source.name,
                        });
                    }
                }
            }

            let metaSourceName = e.target.dataset.name;
            commitLocalUpdate(environment, (store) => {
                const record = store.getRoot().getLinkedRecord("settings");
                record.setValue(e.target.dataset.id, "selectedParentId");
                record.setValue(true, "isParent");
                record.setValue([], "filterTerms");
                record.setValue([], "selectedSentimentPostIds");
                record.setValue([], "selectedLeads");
                record.setValue(metaSourceName, "metaSourceName");
                record.setValue("Articles from ", "metaDescription");
                record.setValue(false, "isBookmarkView");
                record.setValue(false, "isPostNoteView");

                record.setValue(false, "isAdvancedSearch");
                record.setValue("", "hasPhrase");
                record.setValue("", "withoutWords");
                record.setValue("", "withWords");
                record.setValue("", "searchScope");
                record.setValue("", "searchTime");
                record.setValue(false, "allSubscriptions");
                record.setValue(false, "isRightNavActivated");
                record.setValue("{}", "tagData");
                record.setValue(false, "isAddSourcePageActivated");
            });
        }

        let parentArr = [];
        data.forEach((el) => {
            if (el["parentId"] === null) {
                parentArr.push({
                    id: el["id"],
                    parentId: el["parentId"],
                    name: el["name"],
                });
            }
        });

        let rootArr = [];
        parentArr.forEach((p, i) => {
            let nodeArr = [];
            nodeArr.push({ id: p.id, name: p.name, parentId: p.parentId });
            data.forEach((el) => {
                if (el["parentId"] == p["id"]) {
                    nodeArr.push({
                        id: el.id,
                        name: el.name,
                        parentId: el.parentId,
                    });
                }
            });
            rootArr.push(nodeArr);
        });

        const idMapping = (arr) =>
            arr.reduce((acc, el, i) => {
                acc[el.id] = i;
                return acc;
            }, {});

        function getRoot(arr) {
            let root;
            arr.forEach((el) => {
                if (el.parentId === null) {
                    root = el;
                    return;
                }
                const parentEl = arr[idMapping(arr)[el.parentId]];
                parentEl.children = [...(parentEl.children || []), el];
            });

            return root;
        }

        rootArr.forEach((arr, i) => {
            feedArr.push(getRoot(arr));
        });

        let sourceArr = [];
        const parentId = e.target.dataset.id;
        let children = [];

        feedArr.forEach((el) => {
            if (el["id"] == parentId) {
                children = el["children"];
            }
        });

        console.log(children);

        if (children) {
            children.forEach((child) => {
                sourceArr.push(child["id"]);
            });
        }

        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(sourceArr, "selectedSourceId");
            record.setValue(true, "isParent");
        });

        updateLocalSetting("isFullScreenMenuActivated", false);

        navigate("/home");
    }

    return (
        <div>
            {userSub.map((edge, key) => (
                <div key={key}>
                    {edge.node.parent == null ? (
                        <div className={`xparent-details`}>
                            <div name={edge.node.name} id={edge.node.id}>
                                <TreeNodeFolder
                                    settings={settings}
                                    name={edge.node.name}
                                    id={edge.node.id}
                                    onFolderClick={onParentClick}
                                />
                            </div>
                            <div>
                                <TreeEdgesEnclosure
                                    settings={settings}
                                    parentId={edge.node.id}
                                    userSub={userSub}
                                    edge={edge}
                                />
                            </div>
                        </div>
                    ) : null}
                </div>
            ))}
        </div>
    );
}

export default createFragmentContainer(Tree, {
    user_Subscription: graphql`
        fragment Tree_user_Subscription on UserNode {
            userSubscriptions(first: 100)
                @connection(key: "Tree_userSubscriptions") {
                edges {
                    node {
                        id
                        name
                        source {
                            id
                            name
                            edited_name
                            image_url
                            source_icon
                        }
                        parent {
                            id
                        }
                    }
                }
            }
        }
    `,
});
